module.exports = __webpack_public_path__ + "img/public/siteImages/whiteArrow.svg?6ac631b1";